import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { UserState } from '../interface/MyInterfaces';

import { login, changePassword } from '../actions/UserActions';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ApplicationState } from '../reducers/Index';

interface PasswordResetState {
    TheUser?: UserState;
    TheUser_CurrentPassword?: string;
    NewPassword?: string;
}

interface PasswordResetProps {
    UserState?: UserState;
    changePassword?(username?: string, newpassword?: string);
}

class PasswordReset extends React.Component<RouteComponentProps<{}> & PasswordResetProps, PasswordResetState> {
    constructor(props) {
        super(props);
        this.state = {
            TheUser: { username: "", MessageToShow: "" },
            TheUser_CurrentPassword: "",
            NewPassword: ""
        }

        this.handleSubmit = this.handleSubmit.bind(this);
      
        this.handleCurrentPasswordChange = this.handleCurrentPasswordChange.bind(this);
        this.handleNewPasswordChange = this.handleNewPasswordChange.bind(this);

        this.ConfirmPassword = this.ConfirmPassword.bind(this);

    }
    handleSubmit() {
        if (this.state.NewPassword !== "") {
            this.props.changePassword(this.state.TheUser.username, this.state.NewPassword);
        }
    }

    enterPressed(event) {
        var code = event.keyCode || event.which;
        if (code === 13) { //13 is the enter keycode
            this.handleSubmit();
        }
    }

    ConfirmPassword() {
        return (this.state.NewPassword == this.state.TheUser_CurrentPassword);
    }

    handleCurrentPasswordChange(event) {
        this.setState({
            /*TheUser: {
                ...this.state.TheUser,
                password: event.target.value
            },
            NewPassword: event.target.value*/
            TheUser_CurrentPassword: event.target.value
        });
    }

    handleNewPasswordChange(event) {
        this.setState({
            NewPassword: event.target.value
        });
    }

    // Fetches our GET route from the Express server. (Note the route we are fetching matches the GET route from server.js
    callBackendAPI = async () => {
        const response = await fetch('/IRISReportsMicroservice/api/User/email_getuser');
        const body = await response.json();

        if (response.status !== 200) {
            throw Error(body.message)
        }
        return body;
    };

    componentDidMount() {
        this.callBackendAPI()
            .then(res => {
                var user = res;
                this.setState({
                    TheUser: {
                        username: user.username
                    },
                    TheUser_CurrentPassword: user.password
                    //NewPassword: user.password
                })
            })             
            .catch(err => console.log(err));
    }

    public render() {
        return <div className="wrapper">
            <form className="form-signin">
                <h2 className="form-signin-heading">Reset Password</h2>
                 New Password:
                <input type="text" className="form-control" name="username" onChange={this.handleCurrentPasswordChange} value={this.state.TheUser_CurrentPassword} />
                Re-enter New Password:
                <input type="password" className="form-control" name="password" onChange={this.handleNewPasswordChange} placeholder="" onKeyPress={this.enterPressed.bind(this)} />
                <button className="btn btn-lg btn-primary btn-block" type="button" onClick={() => this.handleSubmit()}>Submit</button>
                {!this.ConfirmPassword() &&
                    <label className='incorrectpassword'>
                        Confirm password does not match.
                    </label>
                }
            </form>
        </div>;
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            login: login, changePassword: changePassword
        }, dispatch
    )
}
export default connect(
    (state: ApplicationState) => state.userProperties,
    matchDispatchToProps
)(PasswordReset);
